import { BASE_URLS } from '../config/appConfig';
import { RegionTypes } from '../config/regions';
import { AppRoutes } from '../constants/appRoutes';

export const buildSwitchPlatformUrl = (targetRegion, lang, returnPath) => {
	const base = targetRegion === RegionTypes.SaudiArabia ? BASE_URLS.sa : BASE_URLS.en;
	const returnUrl = encodeURIComponent(returnPath);
	return `${base}/${lang}/${AppRoutes.Login}?returnUrl=${returnUrl}`;
};
